'use client';

import React from 'react';
import { Card, Table, Tag, Typography, Space } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function AuditLogsPage() {
  const auditLogs = [
    {
      key: '1',
      timestamp: '2026-09-14 10:30:15',
      entityType: 'GoodsReceipt',
      entityId: 'GR-2026-09-001',
      fromStatus: 'DRAFT',
      toStatus: 'CONFIRMED',
      action: 'CONFIRM_GR',
      actor: 'Agus Wibowo (Warehouse)',
      reason: 'Physical inspection completed; 800 good, 20 rejected',
    },
    {
      key: '2',
      timestamp: '2026-09-14 09:15:00',
      entityType: 'PurchaseOrder',
      entityId: 'PO-2026-09-001',
      fromStatus: 'DRAFT',
      toStatus: 'ISSUED',
      action: 'ISSUE_PO',
      actor: 'Siti Rahma (Purchaser)',
      reason: 'Consolidated PO issued to PT Packaging Jaya Abadi',
    },
    {
      key: '3',
      timestamp: '2026-09-14 08:45:22',
      entityType: 'PurchaseRequest',
      entityId: 'PR-2026-09-001',
      fromStatus: 'WAITING_APPROVAL',
      toStatus: 'APPROVED',
      action: 'APPROVE_LINE_ITEM',
      actor: 'Budi Santoso (Owner)',
      reason: 'Approved items 1 & 2 for Q4 replenishment',
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>
          System Audit Trail & Status History
        </Title>
        <Text type="secondary">
          AuditLog & StatusHistory recording all entity status transitions and administrative actions.
        </Text>
      </div>

      <Card>
        <Table
          dataSource={auditLogs}
          pagination={false}
          scroll={{ x: 800 }}
          columns={[
            {
              title: 'Timestamp',
              dataIndex: 'timestamp',
              key: 'timestamp',
              render: (ts: string) => (
                <Space>
                  <HistoryOutlined style={{ color: '#8c8c8c' }} />
                  <Text>{ts}</Text>
                </Space>
              ),
            },
            {
              title: 'Entity',
              key: 'entity',
              render: (_: unknown, r: (typeof auditLogs)[0]) => (
                <Space>
                  <Tag color="cyan">{r.entityType}</Tag>
                  <Text strong>{r.entityId}</Text>
                </Space>
              ),
            },
            {
              title: 'Action',
              dataIndex: 'action',
              key: 'action',
              render: (a: string) => <Tag color="blue">{a}</Tag>,
            },
            {
              title: 'Transition',
              key: 'transition',
              render: (_: unknown, r: (typeof auditLogs)[0]) => (
                <span>
                  <Tag>{r.fromStatus || '-'}</Tag> &rarr; <Tag color="green">{r.toStatus}</Tag>
                </span>
              ),
            },
            { title: 'Actor', dataIndex: 'actor', key: 'actor' },
            { title: 'Reason / Remarks', dataIndex: 'reason', key: 'reason', ellipsis: true },
          ]}
        />
      </Card>
    </div>
  );
}
